import { useMemo } from 'react'
import { useHostConfig } from '../../hooks/use-host-config'
import { ClaimFormSchema, StepConfig } from './types'

const REVIEW_STEP: StepConfig = {
  key: 'review',
  schemaKeys: [],
  component: null,
  label: 'Review',
}

export function useClaimFormSteps(schema: ClaimFormSchema | undefined): StepConfig[] {
  const hostConfig = useHostConfig()

  return useMemo(() => {
    if (!schema) {
      return []
    }

    const configuredSteps: StepConfig[] = hostConfig.claimFormConfig?.steps ?? []
    const schemaKeys = Object.keys(schema.properties)

    // Find schema keys not covered by any configured step
    const coveredKeys = new Set(configuredSteps.flatMap((step) => step.schemaKeys))
    const unmappedKeys = schemaKeys.filter((key) => !coveredKeys.has(key))

    // Filter configured steps to only include those whose schema keys exist in the schema
    const activeSteps = configuredSteps.filter((step) =>
      step.schemaKeys.some((key) => schemaKeys.includes(key)),
    )

    // Add generic steps for unmapped keys
    const genericSteps: StepConfig[] = unmappedKeys.map((key) => ({
      key,
      schemaKeys: [key],
      component: null,
      label: key.charAt(0).toUpperCase() + key.slice(1),
    }))

    return [...activeSteps, ...genericSteps, REVIEW_STEP]
  }, [schema, hostConfig])
}
